import React from 'react'
import { Space, Select, Button } from 'antd'
import { SyncOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import { mockCategories, mockDepartments } from '../../utils/mockInventoryData'

const { Option } = Select

const InventoryFilters = ({ filterByCategory, filterByDepartment, filterByStockStatus, resetFilters }) => {
  return (
    <Space className='inventory-filter-group' wrap>
      <Select placeholder='Category' allowClear style={{ width: 150 }} onChange={(value) => filterByCategory(value)}>
        {mockCategories.map((category) => (
          <Option key={category.id} value={category.name}>
            {category.name}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Department'
        allowClear
        style={{ width: 150 }}
        onChange={(value) => filterByDepartment(value)}
      >
        {mockDepartments.map((dept) => (
          <Option key={dept.id} value={dept.code}>
            {dept.name}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Stock Status'
        allowClear
        style={{ width: 150 }}
        onChange={(value) => filterByStockStatus(value)}
      >
        <Option value='Healthy'>Healthy</Option>
        <Option value='Low Stock'>Low Stock</Option>
        <Option value='Out of Stock'>Out of Stock</Option>
        <Option value='Over Stock'>Over Stock</Option>
      </Select>

      <Button icon={<SyncOutlined />} onClick={resetFilters}>
        Reset
      </Button>
    </Space>
  )
}

InventoryFilters.propTypes = {
  filterByCategory: PropTypes.func.isRequired,
  filterByDepartment: PropTypes.func.isRequired,
  filterByStockStatus: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired
}

export default InventoryFilters
